import { useMutation } from '@tanstack/react-query';

import type { TEmailSendResult, TInviteEmailPayload } from '@/services/emailSends';

import { notifyMeta } from '@/lib/notify';
import { emailSendsService } from '@/services/emailSends';
import { errorUtils } from '@/services/errors';

const sendInviteEmail = async (payload: TInviteEmailPayload) => errorUtils.unwrap(await emailSendsService.sendInviteEmail(payload));

const useSendInviteEmail = () => useMutation<TEmailSendResult, Error, TInviteEmailPayload>({
  meta: notifyMeta('inviteEmailSend'),
  mutationKey: ['email-sends', 'invite'],
  mutationFn: sendInviteEmail,
});

export {
  useSendInviteEmail,
};
